export const headCells = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'meetingTopic',
        numeric: false,
        disablePadding: false,
        label: 'Chủ đề cuộc họp',
    },
    {
        id: 'meetingId',
        numeric: false,
        disablePadding: false,
        label: 'ID cuộc họp',
    },
    {
        id: 'startTime',
        numeric: false,
        disablePadding: false,
        label: 'Thời gian bắt đầu',
    },
    {
        id: 'itemsCount',
        numeric: false,
        disablePadding: false,
        label: 'Số lượng tệp',
    },
    {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'Thao tác',
    },
];

export const headCellsWhiteboardShare = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'user_name',
        numeric: false,
        disablePadding: false,
        label: 'whiteboard.table.user',
    },
    {
        id: 'user_permission_id',
        numeric: false,
        disablePadding: false,
        label: 'whiteboard.table.permission',
    },
    {
        id: 'expire_time',
        numeric: false,
        disablePadding: false,
        label: 'whiteboard.table.expireTime',
    },
    {
        id: 'expire_status',
        numeric: false,
        disablePadding: false,
        label: 'whiteboard.table.status',
    },
    {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'whiteboard.table.action',
    },
];

export const headCellsWB = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'table.wbName',
    },
    {
        id: 'created_date',
        numeric: false,
        disablePadding: false,
        label: 'table.created_date',
    },
    {
        id: 'owner_name',
        numeric: false,
        disablePadding: false,
        label: 'table.owner_name',
    },
    {
        id: 'edit',
        numeric: false,
        disablePadding: false,
        label: 'table.edit',
    },
    {
        id: 'is_locked',
        numeric: false,
        disablePadding: false,
        label: 'table.is_locked',
    },
    {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'table.actions',
    },
];

export const headCellsHistoryAction = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'module',
        numeric: false,
        disablePadding: false,
        label: 'table.module',
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'table.action',
    },
    {
        id: 'username',
        numeric: false,
        disablePadding: false,
        label: 'table.username',
    },
    {
        id: 'ip',
        numeric: false,
        disablePadding: false,
        label: 'table.ip',
    },
    {
        id: 'device',
        numeric: false,
        disablePadding: false,
        label: 'table.device',
    },
    {
        id: 'time',
        numeric: false,
        disablePadding: false,
        label: 'table.time',
    }
];

export const headCellsErrorLog = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'module',
        numeric: false,
        disablePadding: false,
        label: 'table.module',
    },
    {
        id: 'error_code',
        numeric: false,
        disablePadding: false,
        label: 'table.error_code',
    },
    {
        id: 'detail_error',
        numeric: false,
        disablePadding: false,
        label: 'table.detail_error',
    },
    {
        id: 'time',
        numeric: false,
        disablePadding: false,
        label: 'table.time',
    }
];

export const headCellsAccessLog = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'username',
        numeric: false,
        disablePadding: false,
        label: 'table.username',
    },
    {
        id: 'ip',
        numeric: false,
        disablePadding: false,
        label: 'table.ip',
    },
    {
        id: 'device',
        numeric: false,
        disablePadding: false,
        label: 'table.device',
    },
    {
        id: 'time',
        numeric: false,
        disablePadding: false,
        label: 'table.time',
    }
];

export const headCellsMyHistoryLog = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'username',
        numeric: false,
        disablePadding: false,
        label: 'table.userName',
    },
    {
        id: 'ip',
        numeric: false,
        disablePadding: false,
        label: 'table.ip',
    },
    {
        id: 'device',
        numeric: false,
        disablePadding: false,
        label: 'table.device',
    },
    {
        id: 'time',
        numeric: false,
        disablePadding: false,
        label: 'table.time',
    }
];

export const headCellsBackup = [
    { id: 'id', numeric: false, disablePadding: false, label: '#' },
    { id: 'path_file', numeric: false, disablePadding: false, label: 'table.pathBackup'},
    { id: 'path_backup', numeric: false, disablePadding: false, label: 'table.storageAdd'},
    // { id: 'time_start_backup', numeric: false, disablePadding: false, label: 'table.timeStartBackup'},
    // { id: 'time_backup', numeric: false, disablePadding: false, label: 'table.timeBackup'},
    { id: 'rule_name', numeric: false, disablePadding: false, label: 'table.ruleName' },
    { id: 'type', numeric: false, disablePadding: false, label: 'table.type'},
    { id: 'description', numeric: false, disablePadding: false, label: 'table.description'},
    { id: 'actions', numeric: false, disablePadding: false, label: 'table.actions'  }
];

export const headCellsPhonebook = [
    { id: 'id', numeric: false, disablePadding: false, label: '#' },
    { id: 'contact_name', numeric: false, disablePadding: false, label: 'table.contactName'},
    { id: 'contact_email', numeric: false, disablePadding: false, label: 'table.contactEmail'},
    { id: 'contact_description', numeric: false, disablePadding: false, label: 'table.contactDescription'},
    { id: 'created_date', numeric: false, disablePadding: false, label: 'table.contactCreatedDate' },
    { id: 'contact_status', numeric: false, disablePadding: false, label: 'table.contactStatus' },
    { id: 'actions', numeric: false, disablePadding: false, label: 'table.actions'  }
];

export const headCellsManageVersion = [
    { id: 'id', numeric: false, disablePadding: false, label: '#' },
    { id: 'name', numeric: false, disablePadding: false, label: 'table.versionName'},
    { id: 'version_code', numeric: false, disablePadding: false, label: 'table.version'},
    { id: 'release_timestamp', numeric: false, disablePadding: false, label: 'table.releaseDate'},
    { id: 'description', numeric: false, disablePadding: false, label: 'table.description' },
    { id: 'released_by_username', numeric: false, disablePadding: false, label: 'table.releaseUser' },
    { id: 'status', numeric: false, disablePadding: false, label: 'table.status'  },
    { id: 'actions', numeric: false, disablePadding: false, label: 'table.actions'  }
];

export const headCellsPackageManagement = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'packageCode',
        numeric: false,
        disablePadding: false,
        label: 'table.packageCode',
    },
    {
        id: 'packageName',
        numeric: false,
        disablePadding: false,
        label: 'table.packageName',
    },
    {
        id: 'packageType',
        numeric: false,
        disablePadding: false,
        label: 'table.packageType',
    },
    {
        id: 'totalLicense',
        numeric: false,
        disablePadding: false,
        label: 'table.totalLicense',
    },
    {
        id: 'assignedAccount',
        numeric: false,
        disablePadding: false,
        label: 'table.assignedAccount',
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'table.action',
    }
];

export const headCellsMemberManagement = [
    { id: 'id', numeric: false, disablePadding: false, label: '#' },
    { id: 'memberName', numeric: false, disablePadding: false, label: 'table.memberName'},
    { id: 'email', numeric: false, disablePadding: false, label: 'table.email'},
    { id: 'status', numeric: false, disablePadding: false, label: 'table.status'},
    {
        id: 'packageName',
        numeric: false,
        disablePadding: false,
        label: 'table.packageName',
    },
    {
        id: 'packageType',
        numeric: false,
        disablePadding: false,
        label: 'table.packageType',
    },
    {
        id: 'licenseCode',
        numeric: false,
        disablePadding: false,
        label: 'table.licenseCode',
    },
    {
        id: 'effectiveTime',
        numeric: false,
        disablePadding: false,
        label: 'table.effectiveTime',
    }
];

export const headCellsDetailPackage = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'licenseCode',
        numeric: false,
        disablePadding: false,
        label: 'table.licenseCode',
    },
    {
        id: 'effectiveTime',
        numeric: false,
        disablePadding: false,
        label: 'table.effectiveTime',
    },
    {
        id: 'assignedUsername',
        numeric: false,
        disablePadding: false,
        label: 'table.assignedUsername',
    },
    {
        id: 'email',
        numeric: false,
        disablePadding: false,
        label: 'table.email',
    },
    {
        id: 'effect',
        numeric: false,
        disablePadding: false,
        label: 'table.effect',
    },
    {
        id: 'action',
    numeric: false,
        disablePadding: false,
        label: 'table.action',
    }
];


export const headCellLandingpage = [
    { id: 'id', numeric: false, disablePadding: false, label: '#' },
    { id: 'eventCode', numeric: false, disablePadding: false, label: 'table.eventCode'},
    { id: 'eventName', numeric: false, disablePadding: false, label: 'table.eventName'},
    { id: 'effectiveTimeEvent', numeric: false, disablePadding: false, label: 'table.effectiveTimeEvent'},
    { id: 'displayModule', numeric: false, disablePadding: false, label: 'table.displayModule'},
    { id: 'eventStatus', numeric: false, disablePadding: false, label: 'table.eventStatus'},
    { id: 'actions', numeric: false, disablePadding: false, label: 'table.actions'}
]

export const headCellsRecordShare = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'user_name',
        numeric: false,
        disablePadding: false,
        label: 'whiteboard.table.user',
    },
    {
        id: 'user_permission_id',
        numeric: false,
        disablePadding: false,
        label: 'whiteboard.table.permission',
    },
    {
        id: 'expire_time',
        numeric: false,
        disablePadding: false,
        label: 'whiteboard.table.expireTime',
    },
    {
        id: 'expire_status',
        numeric: false,
        disablePadding: false,
        label: 'whiteboard.table.status',
    },
    {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'whiteboard.table.action',
    },
];


export function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const headCellsMCUControl = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'roomCode',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.roomCode',
    },
    {
        id: 'roomName',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.roomName',
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.action',
    }
];

export const headCellsMCUStatus = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'Name',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.name',
    },
    {
        id: 'duration',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.duration',
    },
    {
        id: 'rtpChannel',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.rtpChannel',
    },
    {
        id: 'packets',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.packets',
    },
    {
        id: 'rtt',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.rtt',
    },
    {
        id: 'fps',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.fps',
    },
    {
        id: 'losses',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.losses',
    }
];

export const headCellsMCUSettings = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'user',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.user',
    },
    {
        id: 'password',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.password',
    },
    {
        id: 'hostServerSip',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.hostServerSip',
    },
    {
        id: 'lastActive',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.lastActive',
    },
    {
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.status',
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.action',
    }
];

export const headCellsDeviceList = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'deviceCode',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.deviceCode'
    },
    {
        id: 'deviceName',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.deviceName'
    },
    {
        id: 'brand',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.brand'
    },
    {
        id: 'model',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.model'
    },
    {
        id: 'serial',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.serial'
    },
    {
        id: 'room',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.room'
    },
    {
        id: 'sipAccount',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.sipAccount'
    },
    {
        id: 'ip',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.ip'
    },
    {
        id: 'port',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.port'
    },
    {
        id: 'link',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.link'
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'mcu.table.action',
    }
]

export const headCellsOrganization = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'unitCode',
        numeric: false,
        disablePadding: false,
        label: 'unit.table.unitCode',
    },
    {
        id: 'unitName',
        numeric: false,
        disablePadding: false,
        label: 'unit.table.unitName',
    },
    {
        id: 'parentUnit',
        numeric: false,
        disablePadding: false,
        label: 'unit.table.parentUnit',
    },
    {
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: 'unit.table.status',
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'unit.table.action',
    },
]

export const headCellsChildParOrganization = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'displayName',
        numeric: false,
        disablePadding: false,
        label: 'unit.table.displayName',
    },
    {
        id: 'email',
        numeric: false,
        disablePadding: false,
        label: 'unit.table.email',
    },
    {
        id: 'role',
        numeric: false,
        disablePadding: false,
        label: 'unit.table.role',
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'unit.table.action',
    },
]

export const headCellsRoleParOrganization = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'roleCode',
        numeric: false,
        disablePadding: false,
        label: 'unit.table.roleCode',
    },
    {
        id: 'roleName',
        numeric: false,
        disablePadding: false,
        label: 'unit.table.roleName',
    },
    {
        id: 'appliedUnit',
        numeric: false,
        disablePadding: false,
        label: 'unit.table.appliedUnit',
    },
    {
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: 'unit.table.status',
    },
]

export const headCellsGroup = [
    { id: 'id', numeric: false, disablePadding: false, label: '#' },
    { id: 'groupName', numeric: false, disablePadding: false, label: 'phonebook.table.contactGroupName'},
    { id: 'description', numeric: false, disablePadding: false, label: 'table.description' },
    { id: 'type', numeric: false, disablePadding: false, label: 'phonebook.table.type' },
    { id: 'total', numeric: false, disablePadding: false, label: 'phonebook.table.totalMembers' },
    { id: 'status', numeric: false, disablePadding: false, label: 'phonebook.table.status' },
    { id: 'lastUpdate', numeric: false, disablePadding: false, label: 'phonebook.table.lastUpdate' },
    { id: 'actions', numeric: false, disablePadding: false, label: 'table.actions' }
]

export const headCellsGroupDetailUsers = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'displayName',
        numeric: false,
        disablePadding: false,
        label: 'phonebook.table.displayName'
    },
    {
        id: 'email',
        numeric: false,
        disablePadding: false,
        label: 'table.contactEmail'
    },
    {
        id: 'role',
        numeric: false,
        disablePadding: false,
        label: 'phonebook.label.groupRole'
    },
    {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'table.actions'
    }
]